import { render, staticRenderFns } from "./SelectCategoryModal.vue?vue&type=template&id=053d1382&"
import script from "./SelectCategoryModal.vue?vue&type=script&lang=js&"
export * from "./SelectCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports